import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserAlbuminService {
  error = new Subject<string>();
  slug = '/user_albumins';
  resourceName = 'user_albumins';
  allAlbumins?: any;
  albuminsBetween?: any;

  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.allAlbumins) {
      this.allAlbumins = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allAlbumins;
  }

  clearCache() {
    this.allAlbumins = null;
    this.albuminsBetween = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(albumin: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      albumin,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, albumin: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      albumin,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  getGoodAlbumin(gender) {
      return '<3';
  }

  getRagForSex(albumin, sex) {
    let ragColour = '';

    if (+albumin < 3) {
      ragColour = 'green';
    } else if (+albumin > 30) {
      ragColour = 'red';
    } else {
      ragColour = 'amber';
    }

    return ragColour;
  }

  getRangeforColorAndSex(colour: string, sex: string) {
    let ragRange = '';

    if (colour == 'green') {
      ragRange = '<3';
    } else if (colour == 'amber') {
      ragRange = '3-30';
    } else {
      ragRange = '>30';
    }

    return ragRange;
  }
}
